import { axiosCore } from './http-core-service';
import { ResultSearchDto } from './dtos/result-search.dto';
import {
    RelationGeneralDataByTownDto,
    RelationGeneralDataDto,
    RelationIndicatorsBillsDto,
    RelationIndicatorsMetersDto,
    RelationRequestsByTownDto,
    RelationRequestsCountDto,
} from './dtos/relation.dto';
import { PricesDto } from './dtos/prices.dto';

const SUBSCRIBER_RELATION_TIMEOUT = 120000;

/**
 * Récupération de la liste des impayés dans les finances du mandat.
 * @param mandateId identifiant du mandat
 */
export const getRelationRequestByYear = async (mandateId: string): Promise<RelationRequestsCountDto> => {
    // Récupération du doc selon le mandat
    const response = await axiosCore.get(`/api/subscriber-relation/mandates/${mandateId}/requests/year`, {
        timeout: SUBSCRIBER_RELATION_TIMEOUT,
    });
    return response.data;
};

/**
 * Récupération de la liste des demandes communes
 * @param mandateId identifiant du mandat
 * @param page
 * @param itemsPerPage
 */
export const getRelationRequestByTown = async (
    mandateId: string,
    page: number,
    itemsPerPage: number
): Promise<ResultSearchDto<RelationRequestsByTownDto>> => {
    // Pour le back, la page doit être incrémentée une fois
    page = page + 1;

    const response = await axiosCore.get(
        `/api/subscriber-relation/mandates/${mandateId}/requests/city?page=${page}&itemsPerPage=${itemsPerPage}`,
        { timeout: SUBSCRIBER_RELATION_TIMEOUT }
    );
    return response.data;
};

export const getPriceDocument = async (
    mandateId: string,
    page: number,
    itemsPerPage: number
): Promise<ResultSearchDto<PricesDto>> => {
    page = page + 1;

    const response = await axiosCore.get(
        `/api/subscriber-relation/mandates/${mandateId}/prices?page=${page}&itemsPerPage=${itemsPerPage}`
    );
    return response.data;
};

/**
 * Récupération de la liste des indicateurs factures
 * @param mandateId identifiant du mandat
 * @param page
 * @param itemsPerPage
 */
export const getRelationBillsIndicators = async (
    mandateId: string,
    page: number,
    itemsPerPage: number
): Promise<ResultSearchDto<RelationIndicatorsBillsDto>> => {
    // Pour le back, la page doit être incrémentée une fois
    page = page + 1;

    const response = await axiosCore.get(
        `/api/subscriber-relation/mandates/${mandateId}/bills-indicators?page=${page}&itemsPerPage=${itemsPerPage}`
    );
    return response.data;
};

/**
 * Récupération de la liste des indicateurs relèves
 * @param mandateId identifiant du mandat
 * @param page
 * @param itemsPerPage
 */
export const getRelationMetersIndicators = async (
    mandateId: string,
    page: number,
    itemsPerPage: number
): Promise<ResultSearchDto<RelationIndicatorsMetersDto>> => {
    // Pour le back, la page doit être incrémentée une fois
    page = page + 1;

    const response = await axiosCore.get(
        `/api/subscriber-relation/mandates/${mandateId}/meters-indicators?page=${page}&itemsPerPage=${itemsPerPage}`
    );
    return response.data;
};

/**
 * Récupération de la liste des demandes communes
 * @param mandateId identifiant du mandat
 */
export const getRelationGeneralData = async (mandateId: string): Promise<RelationGeneralDataDto> => {
    // Données générales total
    const response = await axiosCore.get(`/api/subscriber-relation/mandates/${mandateId}/general-data/total`, {
        timeout: SUBSCRIBER_RELATION_TIMEOUT,
    });

    return response.data;
};

/**
 * Récupération de la liste des demandes communes
 * @param mandateId identifiant du mandat
 * @param page
 * @param itemsPerPage
 */
export const getRelationGeneralDataByTown = async (
    mandateId: string,
    page: number,
    itemsPerPage: number
): Promise<ResultSearchDto<RelationGeneralDataByTownDto>> => {
    // Pour le back, la page doit être incrémentée une fois
    page = page + 1;

    // Récupérer des données générales par cité
    const response = await axiosCore.get(
        `/api/subscriber-relation/mandates/${mandateId}/general-data/city?page=${page}&itemsPerPage=${itemsPerPage}`,
        { timeout: SUBSCRIBER_RELATION_TIMEOUT }
    );

    return response.data;
};
